import React from "react";

import { Container, Row, Col } from "reactstrap";

function HtxMixingService() {
  return (
    <div className="header">
      <Container>
        <Row>
          <Col className="mx-auto my-5 text-center" lg="10">
            <h1 className="display-2 text-default">
              Is Huobi / HTX a &#8220;compliant&#8221; exchange or just a 
              &#8220;regulated&#8221; mixing service?
            </h1>
          </Col>
        </Row>
        <Row>
          <div className="floating-box rounded mx-3 bg-default">
            <h2 className="lead text-white p-5">
              &#8220;Huobi&#8221; or &#8220;HTX&#8221; as it is now called 
              has been surrounded by controversy and mystery after &#8220;Huobi 
              Global Limited &#40;Seychelles&#41;&#8221; was struck off the 
              company register on October 13, 2023. This came only one month 
              after the official rebrand from &#8220;Huobi&#8221; to &#8220;HTX&#8221; 
              on September 13, 2023.
            </h2>
          </div>
        </Row>
      </Container>
    </div>
  );
}

export default HtxMixingService;
